import { useQuery } from '@tanstack/react-query';
import type { Settlement } from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const settlementQueryKey = (runId: string) =>
  ['admin', 'settlement', runId] as const;

export const useSettlementQuery = (runId: string | undefined) =>
  useQuery<Settlement>({
    queryKey: settlementQueryKey(runId ?? ''),
    enabled: Boolean(runId),
    queryFn: async () => {
      const [data] = await apiClient.request(
        'get',
        '/admin/v1/settlements/{runId}',
        { params: { path: { runId: runId as string } } },
      );
      return data as Settlement;
    },
  });
